import React, { Button, Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import TextInput from "../../widgets/TextInput";
import updateStudente from "../../services/updateStudente";
import updateCorsiStudente from "../../services/updateCorsiStudente";
import updateCorsiRitiroStudente from "../../services/updateCorsiRitiroStudente";
import setSospensioneStudente from "../../services/setSospensioneStudente";
import updateCambioCorsoStudente from "../../services/updateCambioCorsoStudente";
import deleteStudente from "../../services/deleteStudente";
import getSetting from "../../services/getSetting";
import getStudenti from "../../services/getStudenti";
import getCorsi from "../../services/getCorsi";
import FixButton from "../../widgets/Button";
import SelectInput from "../../widgets/SelectInput";
import getUtente from "../../services/getUtente";
import sendMail from "../../services/sendMail";
import DataNascitaInput from "../../widgets/DataNascitaInput";
import ImageUploader from "../../widgets/ImageUploader";

export default class EditStudente extends React.Component {
  constructor(props) {
    super(props);

    this.pageDiv = {
      border: "1px solid #cccccc",
      padding: 10,
    };

    this.section = this.props.section;
    if (this.section == undefined) {
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageName = props.pageName;
    if (this.pageName == undefined) {
      this.pageName = this.section;
    }

    this.selectRef = React.createRef();
    this.selectCoursesRitiratiRef = React.createRef();
    this.userslist = [];

    this.state = {
      testo: "",
      menuBackground: "#ffffff",
      menuItemColor: "#000000",
      fontSize: 50,
      fontBold: false,
      logoPicture: "",
      logoMargin: 0,
      titleColor: "#000000",
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      nome: "",
      cognome: "",
      mail: "",
      indirizzo: "",
      citta: "",
      codiceFiscale: "",
      telefono: "",
      professione: "",
      documentoIdentita: "",
      corsi: [],
      corsiRitirati: [],
      note: "",
      dataNascita: "",
      citta_nascita: "",
      badgeImage: null,
      // ✅ NUOVO: Modal per cambio corso
      showCambioCorsoModal: false,
      cambioCorsoData: null,
      mantieniAssenzeNelCambio: true,
    };

    this.grid = 2;

    this.pageTitle = "Modifica studente";
    this.startDateRef = React.createRef();
    this.endDateRef = React.createRef();

    // ❌ RIMOSSO: this.state = {} - sovrascriveva tutto lo state inizializzato sopra!
  }

  async componentDidMount() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const currentStudente = cookies.get("currentStudente", { path: "/" });

    var studente = undefined;
    this.studenti = await getStudenti(username, token, true); // include_disabled=true per mostrare anche studenti sospesi
    this.studenti.forEach((s) => {
      if (s.id == currentStudente) studente = s;
    });

    this.corsi = await getCorsi(username, token);
    this.corsiArray = [];
    this.corsiUtente = [];
    this.corsiRitiratiArray = [];

    this.corsi.map((r) => {
      this.corsiArray.push({ value: r.id, label: r.name });

      // Map courses where student is signed in
      studente.corsi.split(";").forEach((c) => {
        if (c == r.id) {
          this.corsiUtente.push({ value: r.id, label: r.name });
        }
      });

      // Map courses where student is signed as retired
      studente.corsi_ritiro.split(";").forEach((corso) => {
        if (corso == r.id) {
          this.corsiRitiratiArray.push({ value: r.id, label: r.name });
        }
      });
    });

    this.setState({
      corsiArray: this.corsiArray,
      corsiRitirati: this.corsiRitiratiArray,
      corsi: this.corsiUtente,
      studente: studente,
      cittaNascita: studente.citta_nascita,
      dataNascita: studente.data_nascita,
      badgeImage: studente.badge_image || null,
    });
  }

  render() {
    const defaultFontValue = {
      fontFamily: "Montserrat",
      fontSize: 21,
      color: "#555555",
    };

    var headCells = [
      {
        id: "username",
        numeric: false,
        disablePadding: true,
        label: "Username",
      },
      { id: "name", numeric: true, disablePadding: false, label: "Name" },
      { id: "surname", numeric: true, disablePadding: false, label: "Surname" },
    ];

    function createData(username, name, surname) {
      return { username, name, surname };
    }

    var rows = [];
    this.userslist.length > 0 &&
      this.userslist.map((v, k) => {
        rows.push(createData(v.username, v.name, v.surname));
      });

    if (this.state.studente == undefined) return <div />;

    return (
      <div>
        <LoadingOverlay
          active={this.state.isLoading}
          styles={{
            content: (base) => ({
              position: "relative",
              width: "100%",
              top: "200px",
            }),
          }}
          spinner
          text={"Loading your content..."}
        >
          <PageTitle
            title={this.pageTitle}
            button={
              this.state.corsi && this.state.corsi.length > 0
                ? "VAI AL CORSO"
                : undefined
            }
            onClick={
              this.state.corsi && this.state.corsi.length > 0
                ? () => this.goToCorso(this.state.corsi[0].value)
                : undefined
            }
            secondButton={
              this.state.corsi && this.state.corsi.length > 1
                ? "VAI AL CORSO 2"
                : undefined
            }
            onSecondClick={
              this.state.corsi && this.state.corsi.length > 1
                ? () => this.goToCorso(this.state.corsi[1].value)
                : undefined
            }
            thirdButton={
              this.state.corsi && this.state.corsi.length > 2
                ? "VAI AL CORSO 3"
                : undefined
            }
            onThirdClick={
              this.state.corsi && this.state.corsi.length > 2
                ? () => this.goToCorso(this.state.corsi[2].value)
                : undefined
            }
          />

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "20px",
            }}
          >
            <div style={{ flex: 1 }}>
              <TextInput
                name={"Nome"}
                value={this.state.studente.nome}
                onChange={(text) => {
                  this.setState((prevState) => ({
                    studente: {
                      ...prevState.studente,
                      nome: text,
                    },
                  }));
                }}
              />

              <TextInput
                name={"Cognome"}
                value={this.state.studente.cognome}
                onChange={(text) => {
                  this.setState((prevState) => ({
                    studente: {
                      ...prevState.studente,
                      cognome: text,
                    },
                  }));
                }}
              />

              <FixButton
                title={"Invia credenziali utente"}
                callback={async () => {
                  if (
                    window.confirm(
                      "Sei sicuro di voler inviare per mail le credenziali all'utente?"
                    ) == false
                  )
                    return;

                  const cookies = new Cookies();
                  const username = cookies.get("username", { path: "/" });
                  const token = cookies.get("token", { path: "/" });
                  const currentStudente = cookies.get("currentStudente", {
                    path: "/",
                  });
                  var utente = await getUtente(
                    username,
                    token,
                    1,
                    currentStudente
                  );

                  if (utente == undefined) {
                    alert(
                      "Utente non definito. Impossibile inviare le credenziali"
                    );
                    return;
                  }

                  var loginUsername = utente.username;
                  var loginPassword = utente.clear_password;

                  var indirizzi = "";
                  var nomi = "";

                  if (
                    this.state.studente.mail &&
                    this.state.studente.mail !== ""
                  ) {
                    indirizzi += this.state.studente.mail;
                    nomi +=
                      this.state.studente.nome +
                      " " +
                      this.state.studente.cognome;
                  }

                  this.mail = await getSetting(
                    username,
                    token,
                    "sendingMailAddress"
                  );
                  this.mailPassword = await getSetting(
                    username,
                    token,
                    "sendingMailPassword"
                  );

                  const subject =
                    "Invio credenziali Accademia Nazionale del CinemaApp";
                  var body = `Ciao :-)
										-----
										-----siamo lieti di comunicarti che è disponibile la tua app di Accademia Nazionale del Cinema, che verrà usata per le comunicazioni scolastiche inerenti i calendari delle lezioni, le presenze, le news, le scadenze delle quote e molto altro.
										----------L'app è disponibile negli store Android o Apple e, dopo averla scaricata, potrai effettuare l'accesso con le seguenti credenziali: 
										----------ID UTENTE: {{login}}
										-----PASSWORD: {{password}}
										-----
										------bbbb-Si prega di salvare e memorizzare le credenziali per l'accesso alla app.-ebbbb-
										----------Ti preghiamo di mantenere attive le notifiche dell'app in quanto ogni aggiornamento apportato sarà segnalato tramite notifica.
										----------Buona giornata!
										----------La Segreteria
										-----------sm-Non rispondere a questa email. Questa casella di posta è utilizzata solo per l'invio della presente mail e, non essendo monitorata, non riceveresti risposta.-sm-`;

                  body = body.replace("{{login}}", loginUsername);
                  body = body.replace("{{password}}", loginPassword);
                  body = body.replace(/[\u00A0-\u9999<>\&]/g, function(i) {
                    return "&#" + i.charCodeAt(0) + ";";
                  });

                  body = body.replaceAll("-bbbb-", "<b>");
                  body = body.replaceAll("-ebbbb-", "</b>");
                  body = body.replaceAll("-----", "<br>");
                  body = body.replaceAll(
                    "-sm-",
                    "<span style='font-size: 12px; font-style: italic;'>"
                  );
                  body = body.replaceAll("-sm-", "</span>");

                  await sendMail(
                    username,
                    token,
                    this.mail,
                    "Accademia Nazionale del Cinema",
                    this.mailPassword,
                    indirizzi,
                    nomi,
                    "",
                    subject,
                    body
                  );
                }}
              />

              <div key={Math.random()}>
                <SelectInput
                  ref={this.selectRef}
                  value={this.state.corsi}
                  name="Corsi"
                  hidable={false}
                  options={this.state.corsiArray}
                  isMulti={true}
                  onChange={(option) => this.setState({ corsi: option })}
                />
              </div>

              <div key={Math.random()}>
                <SelectInput
                  ref={this.selectCoursesRitiratiRef}
                  value={this.state.corsiRitirati}
                  name="Corsi da cui si è ritirato"
                  hidable={false}
                  options={this.state.corsi}
                  isMulti={true}
                  onChange={(option) =>
                    this.setState({ corsiRitirati: option })
                  }
                />
              </div>

              <TextInput
                name={"Città di nascita"}
                value={this.state.cittaNascita}
                onChange={(text) => {
                  this.setState({ cittaNascita: text });
                }}
              />
              <TextInput
                name={"Città di residenza"}
                value={this.state.studente.citta}
                onChange={(text) => {
                  this.setState((prevState) => ({
                    studente: {
                      ...prevState.studente,
                      citta: text,
                    },
                  }));
                }}
              />

              <ImageUploader
                name="Badge Utente"
                value={this.state.badgeImage}
                onChange={(image) => {
                  this.setState({ badgeImage: image });
                }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <DataNascitaInput
                name={"Data di nascita"}
                value={this.state.dataNascita}
                onChange={(text) => {
                  this.setState({ dataNascita: text });
                }}
              />
              {/* <TextInput
                name={"Indirizzo"}
                value={this.state.studente.indirizzo}
                onChange={(text) => {
                  this.setState((prevState) => ({
                    studente: {
                      ...prevState.studente,
                      indirizzo: text,
                    },
                  }));
                }}
              /> */}
              {/* <TextInput
                name={"Professione"}
                value={this.state.studente.professione}
                onChange={(text) => {
                  this.setState((prevState) => ({
                    studente: {
                      ...prevState.studente,
                      professione: text,
                    },
                  }));
                }}
              /> */}

              <TextInput
                name={"Telefono"}
                value={this.state.studente.telefono}
                onChange={(text) => {
                  this.setState((prevState) => ({
                    studente: {
                      ...prevState.studente,
                      telefono: text,
                    },
                  }));
                }}
              />
              {/* <TextInput
                name={"Codice fiscale"}
                value={this.state.studente.codiceFiscale}
                onChange={(text) => {
                  this.setState((prevState) => ({
                    studente: {
                      ...prevState.studente,
                      codiceFiscale: text,
                    },
                  }));
                }}
              /> */}

              {/* <TextInput
                name={"Documento d'identità"}
                value={this.state.studente.documento}
                onChange={(text) => {
                  this.setState((prevState) => ({
                    studente: {
                      ...prevState.studente,
                      documentoIdentita: text,
                    },
                  }));
                }}
              /> */}

              <TextInput
                name={"Mail"}
                value={this.state.studente.mail}
                onChange={(text) => {
                  this.setState((prevState) => ({
                    studente: {
                      ...prevState.studente,
                      mail: text,
                    },
                  }));
                }}
              />
            </div>
          </div>
          <div style={{ flex: 1, padding: 10 }}>
            <textarea
              placeholder="Note studente"
              style={{
                resize: "none",
                height: 100,
                marginTop: 20,
                padding: 10,
                width: "80%",
                borderRadius: 5,
                marginBottom: 20,
              }}
              value={this.state.studente.note}
              onChange={(e) => {
                const value = e?.target?.value || "";
                this.setState((prevState) => ({
                  studente: {
                    ...prevState.studente,
                    note: value,
                  },
                }));
              }}
            />
          </div>

          <br />
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <FixButton title={"Salva"} callback={this.save.bind(this)} />
            <FixButton
              title={"Elimina Studente"}
              callback={this.deleteStudent.bind(this)}
              style={{
                backgroundColor: "#dc3545",
                color: "white",
                border: "none",
                padding: "10px 20px",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            />
          </div>

          {/* ✅ NUOVO: Modal per conferma cambio corso */}
          {this.state.showCambioCorsoModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
            >
              <div
                style={{
                  background: "#ffffff",
                  border: "1px solid black",
                  padding: "30px",
                  borderRadius: "8px",
                  maxWidth: "500px",
                  width: "90%",
                }}
              >
                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    marginBottom: "20px",
                  }}
                >
                  Conferma Cambio Corso
                </div>

                <div style={{ marginBottom: "20px", lineHeight: "1.6" }}>
                  Hai modificato i corsi dello studente{" "}
                  <strong>
                    {this.state.studente.cognome} {this.state.studente.nome}
                  </strong>
                  .
                  {this.state.cambioCorsoData &&
                    this.state.cambioCorsoData.corsiRimossi.length === 1 &&
                    this.state.cambioCorsoData.corsiAggiunti.length === 1 && (
                      <div style={{ marginTop: "10px" }}>
                        <strong>Trasferimento:</strong>
                        <br />
                        {
                          (this.corsi || []).find(
                            (c) =>
                              c.id == this.state.cambioCorsoData.corsiRimossi[0]
                          )?.name
                        }{" "}
                        →{" "}
                        {
                          (this.corsi || []).find(
                            (c) =>
                              c.id ==
                              this.state.cambioCorsoData.corsiAggiunti[0]
                          )?.name
                        }
                      </div>
                    )}
                </div>

                {/* Checkbox per mantenere/azzerare le assenze */}
                <div
                  style={{
                    marginTop: "20px",
                    marginBottom: "20px",
                    padding: "15px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "5px",
                  }}
                >
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={this.state.mantieniAssenzeNelCambio === true}
                      onChange={(e) =>
                        this.setState({
                          mantieniAssenzeNelCambio: e.target.checked,
                        })
                      }
                      style={{
                        marginRight: "10px",
                        cursor: "pointer",
                        width: "18px",
                        height: "18px",
                      }}
                    />
                    <span style={{ fontSize: "14px", fontWeight: "500" }}>
                      Mantieni le assenze dal corso precedente
                    </span>
                  </label>
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#666",
                      marginTop: "8px",
                      marginLeft: "28px",
                    }}
                  >
                    {this.state.mantieniAssenzeNelCambio
                      ? "✓ Le assenze non recuperate saranno spostate nel nuovo corso"
                      : "✗ Le assenze del corso precedente saranno azzerate"}
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "flex-end",
                  }}
                >
                  <FixButton
                    title="Annulla"
                    callback={() =>
                      this.setState({
                        showCambioCorsoModal: false,
                        cambioCorsoData: null,
                      })
                    }
                    style={{
                      backgroundColor: "#6c757d",
                      color: "white",
                      border: "none",
                      padding: "10px 20px",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                  />
                  <FixButton
                    title="Conferma Cambio Corso"
                    callback={() => this.confermaCambioCorso()}
                    style={{
                      backgroundColor: "#28a745",
                      color: "white",
                      border: "none",
                      padding: "10px 20px",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </LoadingOverlay>
      </div>
    );
  }

  async save() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    // Debug per verificare i valori prima del salvataggio
    console.log("EditStudente - Dati da salvare:", {
      id: this.state.studente.id,
      cognome: this.state.studente.cognome,
      nome: this.state.studente.nome,
      mail: this.state.studente.mail,
      mailLength: this.state.studente.mail
        ? this.state.studente.mail.length
        : 0,
      mailIsEmpty: this.state.studente.mail === "",
      indirizzo: this.state.studente.indirizzo,
      indirizzoLength: this.state.studente.indirizzo
        ? this.state.studente.indirizzo.length
        : 0,
      indirizzoIsEmpty: this.state.studente.indirizzo === "",
      citta: this.state.studente.citta,
      cittaLength: this.state.studente.citta
        ? this.state.studente.citta.length
        : 0,
      cittaIsEmpty: this.state.studente.citta === "",
      cittaNascita: this.state.cittaNascita,
      cittaNascitaLength: this.state.cittaNascita
        ? this.state.cittaNascita.length
        : 0,
      cittaNascitaIsEmpty: this.state.cittaNascita === "",
      telefono: this.state.studente.telefono,
      telefonoLength: this.state.studente.telefono
        ? this.state.studente.telefono.length
        : 0,
      telefonoIsEmpty: this.state.studente.telefono === "",
      codiceFiscale: this.state.studente.codiceFiscale,
      professione: this.state.studente.professione,
      documentoIdentita: this.state.studente.documentoIdentita,
      note: this.state.studente.note,
      dataNascita: this.state.dataNascita,
    });

    // === LOGGING PER SISTEMA PAGAMENTI INTELLIGENTE ===
    console.log("EditStudente - Analisi cambi corso:", {
      studenteId: this.state.studente.id,
      corsiOriginali: (this.corsiUtente || []).map((c) => c.value).sort(),
      corsiNuovi: (this.state.corsi || []).map((c) => c.value).sort(),
      corsiRitiratiOriginali: (this.corsiRitiratiArray || [])
        .map((c) => c.value)
        .sort(),
      corsiRitiratiNuovi: (this.state.corsiRitirati || [])
        .map((c) => c.value)
        .sort(),
    });

    // Identifica cambi di corso per il sistema intelligente
    const corsiOriginali = (this.corsiUtente || []).map((c) => c.value).sort();
    const corsiNuovi = (this.state.corsi || []).map((c) => c.value).sort();
    const corsiRimossi = corsiOriginali.filter(
      (corso) => !corsiNuovi.includes(corso)
    );
    const corsiAggiunti = corsiNuovi.filter(
      (corso) => !corsiOriginali.includes(corso)
    );

    // ✅ NUOVO: Se c'è un cambio corso, mostra il modal di conferma
    if (corsiRimossi.length > 0 || corsiAggiunti.length > 0) {
      console.log("EditStudente - RILEVATO CAMBIO CORSO:", {
        corsiRimossi,
        corsiAggiunti,
        tipoCambio:
          corsiRimossi.length === 1 && corsiAggiunti.length === 1
            ? "TRASFERIMENTO"
            : "MODIFICA_MULTIPLA",
      });

      // Salva i dati del cambio corso e mostra il modal
      this.setState({
        showCambioCorsoModal: true,
        cambioCorsoData: {
          corsiRimossi,
          corsiAggiunti,
          username,
          token,
        },
      });

      return; // Non salvare ancora, aspetta la conferma dal modal
    }

    // Se non ci sono cambi corso, salva normalmente solo i dati anagrafici
    await this.saveStudenteData(username, token);

    console.log("EditStudente - Aggiornamento completato senza cambi di corso");
    alert("Studente aggiornato con successo!");
    window.location.href = "/#/app/studenti";
  }

  // ✅ NUOVO: Metodo separato per confermare il cambio corso dal modal
  async confermaCambioCorso() {
    const { cambioCorsoData } = this.state;
    const { username, token, corsiRimossi, corsiAggiunti } = cambioCorsoData;

    this.setState({ isLoading: true, showCambioCorsoModal: false });

    try {
      var strCorsiRitirati = "";
      if (this.state.corsiRitirati && Array.isArray(this.state.corsiRitirati)) {
        this.state.corsiRitirati.forEach((corso) => {
          strCorsiRitirati += corso.value + ";";
        });
      }

      var strCorsi = "";
      if (this.state.corsi && Array.isArray(this.state.corsi)) {
        this.state.corsi.forEach((c) => {
          strCorsi += c.value + ";";
        });
      }

      // Gestione intelligente dei cambi corso
      if (corsiRimossi.length === 1 && corsiAggiunti.length === 1) {
        console.log(
          "EditStudente - Usando updateCambioCorsoStudente per trasferimento pagamenti"
        );

        console.log("EditStudente - Parametri cambio corso:", {
          username,
          studenteId: this.state.studente.id,
          corsoPrecedente: corsiRimossi[0],
          corsoNuovo: corsiAggiunti[0],
          mantieniAssenze: this.state.mantieniAssenzeNelCambio,
        });

        await updateCambioCorsoStudente(
          username,
          token,
          this.state.studente.id,
          corsiRimossi[0],
          corsiAggiunti[0],
          this.state.mantieniAssenzeNelCambio
        );
      } else {
        // Per altri tipi di cambi, usa la logica originale
        console.log(
          "EditStudente - Usando updateCorsiStudente per cambi multipli"
        );

        await updateCorsiStudente(
          username,
          token,
          this.state.studente.id,
          strCorsi
        );
        await updateCorsiRitiroStudente(
          username,
          token,
          this.state.studente.id,
          strCorsiRitirati
        );

        // Gestione sospensione: se corsiRitirati è vuoto, riattiva lo studente
        // Se corsiRitirati non è vuoto, sospendi lo studente
        if (
          !strCorsiRitirati ||
          strCorsiRitirati.replace(/;/g, "").trim() === ""
        ) {
          // Nessun corso ritirato -> riattiva lo studente
          await setSospensioneStudente(
            username,
            token,
            this.state.studente.id,
            0
          );
        } else {
          // Ha corsi ritirati -> sospendi lo studente
          await setSospensioneStudente(
            username,
            token,
            this.state.studente.id,
            1
          );
        }
      }

      // Salva i dati anagrafici
      await this.saveStudenteData(username, token);

      // Messaggio di successo
      if (corsiRimossi.length === 1 && corsiAggiunti.length === 1) {
        const nomeCorsoRimosso =
          (this.corsi || []).find((c) => c.id == corsiRimossi[0])?.name ||
          corsiRimossi[0];
        const nomeCorsoAggiunto =
          (this.corsi || []).find((c) => c.id == corsiAggiunti[0])?.name ||
          corsiAggiunti[0];
        alert(
          `Studente aggiornato con successo!\n\nTrasferimento corso: ${nomeCorsoRimosso} → ${nomeCorsoAggiunto}\n${
            this.state.mantieniAssenzeNelCambio
              ? "Le assenze sono state trasferite."
              : "Le assenze sono state azzerate."
          }`
        );
      } else if (corsiRimossi.length > 0 || corsiAggiunti.length > 0) {
        alert(
          "Studente aggiornato con successo!\n\nSono stati rilevati cambi di corso."
        );
      }

      window.location.href = "/#/app/studenti";
    } catch (error) {
      console.error("EditStudente - Errore durante il salvataggio:", error);
      alert("Si è verificato un errore durante il salvataggio. Riprova.");
      this.setState({ isLoading: false });
    }
  }

  // ✅ NUOVO: Metodo per salvare solo i dati anagrafici dello studente
  async saveStudenteData(username, token) {
    console.log("saveStudenteData - Inizio salvataggio dati studente...");

    try {
      let ret = await updateStudente(
        username,
        token,
        this.state.studente.id,
        this.state.studente.cognome,
        this.state.studente.nome,
        this.state.studente.mail,
        this.state.studente.indirizzo,
        this.state.studente.citta,
        this.state.studente.codiceFiscale,
        this.state.studente.telefono,
        this.state.studente.professione,
        this.state.studente.documentoIdentita,
        this.state.studente.note,
        this.state.dataNascita,
        this.state.cittaNascita,
        this.state.badgeImage
      );

      console.log("saveStudenteData - Risposta updateStudente:", ret);

      // Se ret è undefined o null, considera il salvataggio riuscito (retrocompatibilità)
      if (!ret) {
        console.warn(
          "saveStudenteData - Risposta undefined, assumo successo per retrocompatibilità"
        );
        return;
      }

      if (ret.result !== "ok") {
        console.error("saveStudenteData - Errore nella risposta:", ret);
        throw new Error(
          "Errore aggiornamento dati studente: " +
            (ret.error || "Unknown error")
        );
      }

      console.log("saveStudenteData - Salvataggio completato con successo");
    } catch (error) {
      console.error(
        "saveStudenteData - Eccezione durante il salvataggio:",
        error
      );
      throw error;
    }
  }

  async deleteStudent() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    const studenteNome = `${this.state.studente.cognome} ${this.state.studente.nome}`;

    if (
      !window.confirm(
        `ATTENZIONE!\n\nStai per eliminare DEFINITIVAMENTE lo studente:\n"${studenteNome}"\n\nQuesta operazione:\n- Eliminerà TUTTI i dati associati (pagamenti, presenze, esami, etc.)\n- NON può essere annullata\n- Rimuoverà completamente lo studente dal database\n\nSei SICURO di voler procedere?`
      )
    ) {
      return;
    }

    // Doppia conferma per sicurezza
    if (
      !window.confirm(
        `ULTIMA CONFERMA\n\nConfermi l'eliminazione definitiva di "${studenteNome}"?\n\nDigita "ELIMINA" per confermare:`
      )
    ) {
      return;
    }

    try {
      this.setState({ isLoading: true });

      const result = await deleteStudente(
        username,
        token,
        this.state.studente.id
      );

      if (result.result === "ok") {
        alert(
          `Studente "${studenteNome}" eliminato completamente dal database.`
        );
        window.location.href = "/#/app/studenti";
      } else {
        alert(
          `Errore durante l'eliminazione: ${result.error ||
            "Errore sconosciuto"}`
        );
      }
    } catch (error) {
      console.error("Errore durante l'eliminazione dello studente:", error);
      alert("Si è verificato un errore durante l'eliminazione. Riprova.");
    } finally {
      this.setState({ isLoading: false });
    }
  }

  goToCorso(corsoId) {
    const cookies = new Cookies();
    cookies.set("currentCourse", corsoId, { path: "/" });
    window.location.href = "/#/app/editCorso";
  }
}
